import React, { useEffect, useState } from "react";
import { ProductService } from "services/ProductService";
import styles from './LocalizationProductItem.module.scss';
import imageFile from "../../../assets/images/default_product.png";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const LocalizationProductItem = ({ itemId, totalTagsNumber }) => {

    const [product, setProduct] = useState(null);
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        if (itemId) {
            ProductService.product(itemId).then((response) => {
                setProduct(response);
            },
            (error) => {
                setProduct(null);
            });
        } else {
            setProduct(null);
        }
    }, [itemId]);


    return (
        <>
            {product && (
                <div className={styles["localization-product-item"]}>
                    <img src={!product?.image || imageError ? imageFile : product.image}
                        onError={() => { setImageError(true) }} />
                    <div className={styles["localization-product-data"]}>
                        <div>
                            {product?.name}
                        </div>
                        <div className={styles["localization-product-sku"]}>
                            {i18n.t("sku")} {product?.sku}
                        </div>
                    </div>
                    {totalTagsNumber && (
                      <div className={styles["localization-product-item-total"]}>
                      <span className={styles["localization-product-data"]} >{capitalize(i18n.t("total"))}:</span> <span className={styles["localization-product-sku"]} >{totalTagsNumber} {capitalize(i18n.t("tags"))}</span>
                      </div>
                    )}
                </div>
            )}
        </>
    );
};

export default LocalizationProductItem;